// @core/api/endpoints/tenant/suspend_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SuspendTenantRequest,
  TenantResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Suspend tenant
 * Suspends a tenant, restricting access to its resources. Can be triggered by platform admins for policy violations, billing issues, or by automated systems. Suspension details and reactivation conditions are recorded.
 */
export async function SuspendTenant(
  tenant_id: string,
  data: SuspendTenantRequest,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/suspend`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantResponse>(requestPath, data, requestOptions);
}
